import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=75f4b54e&scoped=true&"
import script from "./BalanceView.vue?vue&type=script&lang=js&"
export * from "./BalanceView.vue?vue&type=script&lang=js&"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=75f4b54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f4b54e",
  null
  
)

/* custom blocks */
import block0 from "./BalanceView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports